import { SVGProps, Ref, forwardRef } from 'react';

export const BracketsOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M3.1 16A3.1 3.1 0 0 0 0 12.9v-1.8l.16-.004A3.1 3.1 0 0 0 3.1 8V1H8v1.8H4.9V8c0 1.652-.82 3.112-2.073 4A4.89 4.89 0 0 1 4.9 16v5.2H8V23H3.1zm16 0c0-1.653.819-3.113 2.072-4A4.9 4.9 0 0 1 19.1 8V2.8H16V1h4.9v7a3.1 3.1 0 0 0 2.94 3.096l.16.004v1.8a3.1 3.1 0 0 0-3.1 3.1v7H16v-1.8h3.1zm-3.295-9.597-6 12-1.61-.806 6-12z"
            fill="currentColor"
        />
    </svg>
));
BracketsOutlinedSize24Glyph.displayName = 'BracketsOutlinedSize24Glyph';
